<template>
  <d-form @submit.prevent="sync">
    <d-row class="mx-0 row-table">
      <d-col class="col-table">
        <table class="table mb-0 table-striped">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="p-2 align-middle border-0">Todos os Jogos</th>
              <th scope="col" class="p-2 border-0">
                <d-select
                  class="navbar-search form-control-sm"
                  v-model="filters.orderby"
                  @change="changeFilter($event, 'orderby')"
                >
                <option :value="null">Todos</option>
                <option value="less_used">Menos usados</option>
                </d-select>
              </th>
            </tr>
            <tr>
              <th scope="col" class="border-0" colspan="2">
                <input
                  class="navbar-search form-control"
                  type="text"
                  placeholder="Procurar jogo..."
                  aria-label="Search"
                  v-model="filters.search"
                  @change="changeFilter($event.target.value, 'search')"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in detachedPuzzles.list" :key="index">
              <td :class="['td-4', isSelected(row) ? 'selected' : '']" @click="selectRow(row, 'attached')" colspan="2">
                <span>#{{ row.id }} - <small>{{ row.published_date }}</small></span>
              </td>
            </tr>
            <tr v-if="detachedPuzzles.length === 0">
              <td class="no-content" colspan="2">Ainda não tem nenhum jogo cadastrado.</td>
            </tr>
          </tbody>
        </table>
        <pagination
          :total-items="detachedPuzzles.total_items"
          :pagination="filters"
          :event-name="SYNC_PAGINATION"
        />
      </d-col>
      <d-col cols="1" class="d-flex justify-content-center button-sync">
        <d-button class="btn-outline-info btn-sm" @click.prevent="sync">
          <i class="material-icons">sync_alt</i>
        </d-button>
      </d-col>
      <d-col class="col-table">
        <table class="table mb-0 table-sync table-striped">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Jogos Relacionados <small v-if="attachedPuzzles.length">({{attachedPuzzles.length}})</small></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in attachedPuzzles"
              :key="index"
              :class="['align-items-center', isSelected(row) ? 'selected' : '']"
              @click="selectRow(row, 'detached')">
              <td>
                <span>#{{ row.pivot.puzzle_no }} [ID: {{ row.id }}] - <small>{{ row.published_date }}</small></span>
              </td>
            </tr>
            <tr v-if="attachedPuzzles.length === 0" class="align-items-center">
              <td class="no-content">Ainda não tem nenhum jogo atribuido.</td>
            </tr>
          </tbody>
        </table>
      </d-col>
    </d-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import MagazineService from '_services/rest/modules/magazine';
import Pagination from '_shared/Pagination.vue';
import { ATTACHED } from './MagazineModel';

const SYNC_PAGINATION = 'sync:puzzle-pagination';

export default {
  name: 'magazine-puzzles',
  components: {
    Pagination,
  },
  props: {
    type_id: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    type_id(value) {
      this.filters.type_id = value;
      this.getPuzzles();
    },
  },
  computed: {
    detachedPuzzles() {
      const { detachedPuzzles } = this.$store.state.magazine;
      if (detachedPuzzles) {
        return detachedPuzzles;
      }
      return [];
    },
    attachedPuzzles() {
      const { attachedPuzzles } = this.$store.state.magazine;
      if (attachedPuzzles) {
        return attachedPuzzles;
      }
      return [];
    },
  },
  data() {
    return {
      SYNC_PAGINATION,
      loading: false,
      filters: {
        search: '',
        orderby: null,
        skip: 0,
        take: 25,
        page: 1,
        type_id: this.type_id,
      },
      type: null,
      magazine_id: this.$route.params.magazineId,
      puzzlesSelected: [],
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getAttachedMagazinePuzzles',
    ]),
    changeFilter(event, key = 'filter') {
      this.filters[key] = event;
      this.getPuzzles();
    },
    attach() {
      this.syncAttacherPuzzles(this.preparAttached());
    },
    detach() {
      this.syncAttacherPuzzles(this.preparDetached());
    },
    getPuzzles() {
      if (this.magazine_id) {
        this.getAttachedMagazinePuzzles({ id: this.magazine_id, filters: this.filters });
      }
    },
    isSelected(row) {
      if (this.puzzlesSelected.includes(row)) {
        return true;
      }
      return false;
    },
    preparAttached() {
      return [...this.attachedPuzzles.map(row => row.id), ...this.puzzlesSelected.map(row => row.id)];
    },
    preparDetached() {
      return this.attachedPuzzles.filter(row => !this.puzzlesSelected.includes(row)).map(row => row.id);
    },
    saveError(error) {
      this.loading = false;
      this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
    },
    saveSuccess() {
      this.puzzlesSelected = [];
      this.loading = false;
      this.getPuzzles();
      this.activeAlert({ message: 'Sincronização salva com sucesso', theme: 'success' });
    },
    selectRow(row, type) {
      if (type !== this.type) {
        this.type = type;
        this.puzzlesSelected = [];
      }
      if (row.disabled) {
        return false;
      }
      const index = this.puzzlesSelected.indexOf(row);
      if (index > -1) {
        return this.puzzlesSelected.splice(index, 1);
      }
      return this.puzzlesSelected.push(row);
    },
    sync() {
      this.loading = true;
      if (this.type === ATTACHED) {
        return this.attach();
      }
      return this.detach();
    },
    syncAttacherPuzzles(attachedPuzzles) {
      return MagazineService.syncPuzzles({ puzzles: attachedPuzzles }, this.magazine_id)
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
  },
  mounted() {
    this.getPuzzles();
    Events.$on(SYNC_PAGINATION, pagination => {
      this.filters.page = pagination.page;
      this.filters.skip = pagination.skip;
      this.getPuzzles();
    });
  },
};
</script>

<style lang="scss">
.col-table {
  .pagination__wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
  }
}
</style>
<style lang="scss" scoped>
@import '~_scss/overrides';
form {
  width: 100%;
}
.row-table {
  display: flex;
  height: 100%;
  width: 100%;
  .button-sync {
    position: relative;
    .btn-primary {
      position: sticky;
      height: 30px;
      top: 50%;
    }
  }
  .col-table {
    height: 100%;
    padding: 0;
    border: 1px solid #ccc;
    border-radius: 0.3rem;
  }
}

.table {
  .no-content {
    vertical-align: middle;
  }
  .selected {
    background: lighten($cyan, 45%);
  }
  &-sync {
    tr td{
      height: 47px;
    }
  }
}
.btn-outline-info {
  font-size: 1.4rem;
  padding: 0px 10px;
}
</style>
